var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignRight = function SvgIconAlignRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2.75a1 1 0 0 1 1 1v16.5a1 1 0 1 1-2 0V3.75a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 9.375a1.75 1.75 0 0 1-1.75 1.75H7.5a1.75 1.75 0 0 1-1.75-1.75V6c0-.966.784-1.75 1.75-1.75h8.25c.966 0 1.75.784 1.75 1.75zm-2-.25V6.25H7.75v2.875zM3.75 12.875A1.75 1.75 0 0 0 2 14.625V18c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 17.5 18v-3.375a1.75 1.75 0 0 0-1.75-1.75zM4 17.75v-2.875h11.5v2.875z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlignRight;